import { Button, Modal } from 'react-bootstrap'

/**
 * Shown once an account has been created but its email still has to be confirmed: the
 * client-portal API has just sent the confirmation email, and the user cannot log in until
 * they follow it. `onConfirm` is the primary action (go to Log In); `onHide` is the header X,
 * which the signup pages also point at Log In (AB#40424 AC2: dismissing returns to login).
 */
const ConfirmEmailModal = ({ show, email, onConfirm, onHide }) => {
	return (
		<Modal
			show={show}
			onHide={onHide || onConfirm}
			centered
			backdrop='static'
			aria-labelledby='confirm-email-modal-title'
		>
			<Modal.Header closeButton className='mx-3 mt-2'>
				<h5 id='confirm-email-modal-title' className='mb-0 fw-bold'>
					Check your email
				</h5>
			</Modal.Header>
			<Modal.Body className='px-4 text-center'>
				<p className='mb-2'>Your account has been created.</p>
				<p className='mb-0'>
					We just sent a confirmation email to{' '}
					{email ? <strong className='text-break'>{email}</strong> : 'your email address'}
					. Open it and confirm your account before you log in.
				</p>
				<Button
					className='w-50 mt-4 mb-2 text-uppercase'
					variant='primary'
					onClick={onConfirm}
				>
					Go to Log In
				</Button>
			</Modal.Body>
		</Modal>
	)
}

export default ConfirmEmailModal
